define.alias("checkout/components/containers/load-checkout-data", "calendar/components/containers/load-checkout-data");